import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';
import { getBaseUrl } from "../../Utils/Utils";

const loginUser = createAsyncThunk('login/user', async(userData) =>{
    try {
        const url = getBaseUrl();
        const response = await axios.post(`${url}/user/login`, userData);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        if (error.response?.status === 403 && error.response?.data?.emailVerificationPending) {
            return { emailVerificationPending: true };
        }
    }
});

export {loginUser};